export default {
  zhongtong: '中通快递',
  shunfeng: '顺丰快递',
  ems: 'EMS速递',
  shentong: '申通快递',
  yuantong: '圆通快递',
  yunda: '韵达快递',
  huitongkuaidi: '百世汇通',
  ziqu: '自取',
};



// WEBPACK FOOTER //
// ./src/maps/express-map.js